<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Layout from './components/Layout.vue'
import { useGenerationStore } from './stores/generation'

const route = useRoute()
const generationStore = useGenerationStore()

// Initialize generation store (reconnect to any active generations from localStorage)
onMounted(() => {
  generationStore.init()
})
const isAdminRoute = computed(() => route.path.startsWith('/admin'))
const isPublicRoute = computed(() => {
  const publicPaths = ['/welcome', '/pricing', '/changelog', '/privacy', '/terms']
  return publicPaths.some(path => route.path === path)
})
const isStandaloneRoute = computed(() => isAdminRoute.value || isPublicRoute.value)
</script>

<template>
  <div v-if="isStandaloneRoute" class="w-full">
    <!-- Standalone pages (admin and public), no Layout wrapper - allow scrolling -->
    <router-view />
  </div>
  <div v-else class="w-full h-screen">
    <!-- Regular pages with Layout wrapper -->
    <Layout />
  </div>
</template>
